export default function RPSRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Rock, Paper, Scissors</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVE</b></h3>
                                            <p class="pt20">To predict the outcome of the virtual hand (Rock, Paper, or Scissors). If your selected option matches the hand shown, you win.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>Single Hand Reveal:</b> The system will reveal one hand randomly (Rock, Paper, or Scissors) each round.</p>
                                            <p class="pt20"><b>Placing Bets:</b> Players can place a bet on either Rock, Paper, or Scissors before the countdown ends. Only one selection is allowed per round.</p>
                                            <p class="pt20"><b>Winning Condition:</b> If the revealed hand matches your selected bet, you win the round.</p>
                                            <p class="pt20"><b>Example:</b> If you bet on Paper and the hand reveals Paper, you win and receive a payout according to the odds (2.9).</p>
                                        </div>

                                        <h3><b>PAYOUT</b></h3>
                                        <div>
                                            <div>
                                                <div>
                                                    <p class="pt20">For each winning bet:</p>
                                                    <p class="pt20">The payout is calculated as follows:</p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>Bet Type</th>
                                                                <th>Odds</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Rock</th>
                                                                <th>2.9</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Paper</th>
                                                                <th>2.9</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Scissors</th>
                                                                <th>2.9</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            )}
        </>
    );
}